import pure from "../higher-order/pure";
import React from "react";
import Step from "../step";
import Steps from "../steps";

export default pure(function WithdrawSteps({ isConfirmation, isMethod, isW9, session, withdraw }) {
  var amount = withdraw.get("amount") || 0.0;
  var confirmStep;
  if (session.get("w_9_received") || amount < 600) {
    confirmStep = (
      <Step selected={isConfirmation}>
        Withdrawal Confirmation
      </Step>
    );
  } else {
    confirmStep = (
      <Step selected={isW9}>
        W-9 Form
      </Step>
    );
  }
  return (
    <Steps>
      <Step>
        Withdrawal Amount
      </Step>

      <Step selected={isMethod}>
        Payout Method
      </Step>

      {confirmStep}
    </Steps>
  );
});
